import { Select as MuiSelect, SelectChangeEvent, FormControl, Box, MenuItem } from '@mui/material';
import { ItemType } from 'typings';

interface SelectProps {
  value: string;
  defaultValue?: string;
  onChange: (e?: SelectChangeEvent) => void;
  name: string;
  items: ItemType[];
  label?: string;
  size?: any;
  styles?: any
}

export function Select({ value, defaultValue = '', onChange, name, items, label, size = 'small', styles = {} }: SelectProps): JSX.Element {
  return (
    <Box>
      {label && (
        <div className="bt">
          {label}
        </div>
      )}
      <FormControl sx={{ minWidth: 150 }}>
        <MuiSelect
          MenuProps={{ disableScrollLock: true }}
          value={value}
          defaultValue={defaultValue}
          name={name}
          displayEmpty
          onChange={onChange}
          size={size}
          style={styles ? styles : {}}
        >
          {items.map((item: any) => {
            let divide = item?.divider || item.label === 'All'
            const content = [<MenuItem key={item.key} value={item.key} divider={divide}>{item.label}</MenuItem>];
            return content
          })}
        </MuiSelect>
      </FormControl>
    </Box>
  );
}